import { render, staticRenderFns } from "./OrganizationsSettings.vue?vue&type=template&id=16b808a5&scoped=true"
import script from "./OrganizationsSettings.vue?vue&type=script&lang=js"
export * from "./OrganizationsSettings.vue?vue&type=script&lang=js"
import style0 from "./OrganizationsSettings.vue?vue&type=style&index=0&id=16b808a5&prod&lang=scss"
import style1 from "./OrganizationsSettings.vue?vue&type=style&index=1&id=16b808a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b808a5",
  null
  
)

export default component.exports